import { xesTrackClick, xesTrackPv, xesTrackShow, xesTrackStatus } from '@/trace/xesTrack';

const page_name = 'pcpaperdetail';

export const pvPcpaperdetailBlankBlank = function (value: object = {}) {
  xesTrackPv('pv_pcpaperdetail_blank_blank', {
    page_name,
    event_name: 'PC试卷详情页浏览',
    ...value,
  });
};

export const showPcpaperdetailEndtryBlank = function (value: object = {}) {
  xesTrackShow('show_pcpaperdetail_endtry_blank', {
    page_name,
    event_name: '曝光试看结束引导模块',
    module_name: 'endtry',
    button_name: 'picbutton',
    ...value,
  });
};

export const clickPcpaperdetailEndtryPicbutton = function (value: object = {}) {
  xesTrackClick('click_pcpaperdetail_endtry_picbutton', {
    page_name,
    event_name: '点击试看结束引导图片',
    module_name: 'endtry',
    button_name: 'picbutton',
    ...value,
  });
};

export const showPcpaperdetailBlankDownload = function (value: object = {}) {
  xesTrackShow('show_pcpaperdetail_blank_download', {
    page_name,
    event_name: '试卷宝详情页下载/详解版/答案版曝光',
    module_name: 'blank',
    button_name: 'detail',
    ...value,
  });
};

export const clickPcpaperdetailBlankDownload = function (value: object = {}) {
  xesTrackClick('click_pcpaperdetail_blank_download', {
    page_name,
    event_name: '试卷宝详情页下载/详解版/答案版点击',
    module_name: 'blank',
    button_name: 'detail',
    ...value,
  });
};
